<template>
  <Modal
    full-height
    :loading="isLoading"
    :modal-style="{ maxWidth: '900px' }"
    offset-menu
  >
    <template #header>
      <div
        v-if="range"
        class="row no-wrap"
      >
        <div>
          <img
            :alt="$t('modals.view_transcript_modal.source_logo')"
            class="q-mr-sm"
            :src="mention.source.logo_url"
            style="width: 35px"
          />
        </div>
        <div class="column no-wrap">
          <strong>
            {{
              mention.program_airing
                ? mention.program_airing.name
                : mention.source.name
            }}
          </strong>
          <div>
            <span>
              {{
                $t("modals.view_transcript_modal.time_range", {
                  after: formatIntlDate(
                    addTimeZone(range.after, mention.source.time_zone),
                    { timeStyle: "short" }
                  ),
                  before: formatIntlDate(
                    addTimeZone(range.before, mention.source.time_zone),
                    { timeStyle: "short" }
                  ),
                })
              }}
              <StreemTooltip>
                {{
                  getDateTimeZoneOffset(
                    new Date(),
                    mention.source.time_zone
                  ) === 0
                    ? $t("modals.view_transcript_modal.your_time_tooltip")
                    : $t("modals.view_transcript_modal.location_time_tooltip", {
                        location: menntion.source.location,
                      })
                }}
              </StreemTooltip>
            </span>
            on
            <strong>{{ mention.source.name }}</strong>
            {{ mention.source.location }}
            <span
              class="q-ml-md pointer"
              style="vertical-align: -3px"
              @click="downloadPdf"
            >
              <img
                alt="PDF"
                src="/pdf.svg"
                style="width: 22px"
              />
              <StreemTooltip>{{
                $t("modals.view_transcript_modal.generate_transcript_tooltip")
              }}</StreemTooltip>
            </span>
          </div>
          <div class="q-mt-xs">
            {{
              formatIntlDate(
                addTimeZone(range.after, mention.source.time_zone),
                {
                  dateStyle: "medium",
                }
              )
            }}:
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="!isLoading"
      class="transcript"
    >
      <TVMentionTranscript
        :big-thumbnails="$isDesktop"
        :caption-fragments="fragments"
        :keywords="keywords"
        :loading="isLoading"
        :mention="mention"
        :thumbnails="thumbnails"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import TVMentionTranscript from "shared/components/TVMentionTranscript.vue";
import { useTranscriptData } from "shared/composables/useTranscriptData";
import {
  addTimeZone,
  formatIntlDate,
  getDateTimeZoneOffset,
} from "shared/helpers/date";
import {
  openChannelTranscript,
  openProgramTranscript,
} from "shared/helpers/external";

export default {
  name: "ViewTranscriptModal",
  components: {
    Modal,
    TVMentionTranscript,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
    keywords: {
      type: Array,
      default: () => [],
    },
  },
  setup({ mention }) {
    const { fragments, thumbnails, range, isLoading, fetchTranscriptData } =
      useTranscriptData({ mention });

    return {
      fragments,
      thumbnails,
      range,
      isLoading,
      fetchTranscriptData,
    };
  },
  data() {
    return {
      addTimeZone,
      getDateTimeZoneOffset,
    };
  },
  async mounted() {
    await this.fetchTranscriptData();
  },
  methods: {
    formatIntlDate,
    downloadPdf() {
      this.$modals.open("TranscriptDownloadConfirmModal", {
        events: {
          confirm: (thumbnails) => {
            const params = {
              ...this.range,
              limit: 1000,
              hide_thumbnails: !thumbnails,
            };

            if (this.mention.program_airing) {
              openProgramTranscript(this.mention.program_airing.id, params);
            } else {
              openChannelTranscript(this.mention.source.id, params);
            }
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.transcript {
  max-width: 700px;
  margin: 0 auto;
  padding: var(--s-spacing-lg);
}
</style>
